import axiosInstance from "../../../../config/apiConfig"; 
import { useQuery } from "@tanstack/react-query";

const fetchBlockedUsers = async () => {
  try {
    const { data } = await axiosInstance.get('reports/blocked-users');
    return data.value.items;
  } catch (error) {
    console.error('Error fetching blocked users:', error.response?.data || error.message);
    return [];
  }
};

 const useBlockedUsers = () => {
  return useQuery({
    queryKey: ['blockedUsers'],
    queryFn: fetchBlockedUsers,
    staleTime: 1000 * 60 * 5, 
  });
};

export default useBlockedUsers